import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-4 border-b border-border bg-background/88 px-4 pb-5 pt-6 backdrop-blur-sm sm:px-6 lg:flex-row lg:items-start lg:justify-between lg:gap-6 lg:px-8 lg:pt-7">
      <div className="min-w-0">
        <h1 className="text-[1.8rem] font-semibold leading-tight tracking-tight text-foreground sm:text-2xl">
          {title}
        </h1>
        {description && (
          <p className="mt-2 max-w-3xl text-[15px] leading-6 text-muted-foreground sm:text-sm">{description}</p>
        )}
      </div>
      {actions && (
        <div className="flex flex-wrap items-center gap-2.5 lg:mt-1 lg:shrink-0">{actions}</div>
      )}
    </div>
  );
}
